import axiosInstance from "services/HttpService";
import { URL_LOGIN, URL_ME } from "../constants/url";
import { AxiosError } from "axios";

export const postLogin = async (credentials) => {
  return axiosInstance
    .post(URL_LOGIN, credentials)
    .then((response) => {
      const data = response.data.data;

      localStorage.setItem("user", JSON.stringify(data.user));
      localStorage.setItem("token", data.token);

      return {
        user: data.user,
      };
    })
    .catch((error) => {
      let message = "Ocurrio un error desconocido";

      if (error instanceof AxiosError) {
        message = error.response?.data?.message
          ? error.response.data.message
          : message;
      }

      return { error: message };
    });
};

export const getMe = async () => {
  return axiosInstance.get(URL_ME).then((response) => {
    const data = response.data.data;

    return data.user;
  });
};
